module.exports = __webpack_public_path__ + "static/bar-grey-0a00eea2f1df3b849ecf884f32162248.png";